const BETA_HOST_BY_APP_HOST: Record<string, string> = {
  localhost: 'beta.dev-purchasing.mainstem.io',
  '127.0.0.1': 'beta.dev-purchasing.mainstem.io',
  'dev-purchasing.mainstem.io': 'beta.dev-purchasing.mainstem.io',
  'demo-purchasing.mainstem.io': 'beta.demo-purchasing.mainstem.io',
  'purchasing.mainstem.io': 'beta.purchasing.mainstem.io'
}

export const getBetaAppUrl = (hostname: string, token: string): string | null => {
  const betaHost = BETA_HOST_BY_APP_HOST[hostname]
  if (!betaHost || !token) {
    return null
  }

  return `https://${betaHost}/impersonate/${encodeURIComponent(token)}`
}
